import * as Types from '../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckIfHasPriceListQueryVariables = Types.Exact<{
  facilityId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type CheckIfHasPriceListQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceListMeta?: { readonly __typename?: 'PriceListMeta', readonly id: string } | null } };


export const CheckIfHasPriceListDocument = gql`
    query checkIfHasPriceList($facilityId: ID) {
  priceListV2 {
    priceListMeta(input: {facilityId: $facilityId}) {
      id
    }
  }
}
    `;

/**
 * __useCheckIfHasPriceListQuery__
 *
 * To run a query within a React component, call `useCheckIfHasPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfHasPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfHasPriceListQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useCheckIfHasPriceListQuery(baseOptions?: Apollo.QueryHookOptions<CheckIfHasPriceListQuery, CheckIfHasPriceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfHasPriceListQuery, CheckIfHasPriceListQueryVariables>(CheckIfHasPriceListDocument, options);
      }
export function useCheckIfHasPriceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfHasPriceListQuery, CheckIfHasPriceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfHasPriceListQuery, CheckIfHasPriceListQueryVariables>(CheckIfHasPriceListDocument, options);
        }
export type CheckIfHasPriceListQueryHookResult = ReturnType<typeof useCheckIfHasPriceListQuery>;
export type CheckIfHasPriceListLazyQueryHookResult = ReturnType<typeof useCheckIfHasPriceListLazyQuery>;
export type CheckIfHasPriceListQueryResult = Apollo.QueryResult<CheckIfHasPriceListQuery, CheckIfHasPriceListQueryVariables>;